import React, { FC } from "react";
import { Styled } from "./Add.styled";

const Add: FC = () => {
  return <Styled.AddLogo />;
};

export default Add;
